import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { Button, Flex, Form, Input, Typography } from 'antd';

import messages from '../../constants/messages';

import { resetEmail } from '../../redux/actions/user';

import { errorToastHandler } from '../../components/action_notifier';

import AuthLayout from '../../layouts/AuthLayout';

const { Text, Title } = Typography;

function RecoverPassword() {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const values = Form.useWatch([], form);

  const [submittable, setSubmittable] = useState(false);

  const [state, setState] = useState({
    show: true,
    message: 'You will receive a reset link shortly.'
  });

  useEffect(() => {
    form
      .validateFields({ validateOnly: true })
      .then(() => setSubmittable?.(true))
      .catch(() => setSubmittable?.(false));
  }, [values]);

  async function doReset(event) {
    event.preventDefault();
    try {
      const { email } = await form.validateFields();
      await dispatch(resetEmail({ email, link_type: 'dashboard' }));
      setState(prev => ({ ...prev, show: false }));
    } catch (error) {
      errorToastHandler(error?.message || error?.response?.data?.message || messages.DEFAULT_ERROR);
    }
  }

  return (
    <AuthLayout asideContent={{ text: 'Forgot password?', subtext: "No worries, we'll help you." }}>
      {state.show && (
        <Flex vertical justify="space-between" className="h-full">
          <Flex vertical>
            <Title level={3} className="mb-4">
              Forgot Password?
            </Title>
            <Text type="secondary">Please enter your email and we will send you a new password.</Text>
          </Flex>

          <Form
            form={form}
            className="mt-3"
            layout="vertical"
            requiredMark={false}
            size="small"
            initialValues={{ email: null }}>
            <Form.Item
              label="Email"
              name="email"
              colon={false}
              rules={[
                { required: true, message: messages.FIELD_REQUIRED('Email') },
                { type: 'email', message: messages.FIELD_INVALID('Email') }
              ]}>
              <Input size="large" addonBefore={<i className="fas fa-at"></i>} placeholder="Email" />
            </Form.Item>
          </Form>

          <Flex vertical gap="middle">
            <Button className="w-100 mt-4" size="large" type="primary" disabled={!submittable} onClick={doReset}>
              Send reset link
            </Button>

            <div className="text-center">
              Back to{' '}
              <Link to="/auth/login" className="ml-1">
                Sign in
              </Link>
            </div>
          </Flex>
        </Flex>
      )}
      {!state.show && <p className="pad-30">{state.message}</p>}
    </AuthLayout>
  );
}

export default RecoverPassword;
